import React, { FC } from 'react';
import { Button as AntdButton, ButtonProps as AntdButtonProps } from 'antd';
import { DeleteIcon } from '~/img';

const DeleteButton: FC<AntdButtonProps> = (props) => {
  return <AntdButton size="middle" type="default" icon={<DeleteIcon />} {...props} />;
};

export default DeleteButton;
